/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSON, FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSON, FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSON, } from '../models/index';
/**
 *
 */
export class CrossPlayApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesCrossPlayGetEventRulesEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesCrossPlayGetEventRulesEndpoint().');
        }
        const queryParameters = {};
        if (requestParameters['game'] != null) {
            queryParameters['Game'] = requestParameters['game'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/cross-play/events/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSON));
    }
    /**
     */
    async fxIdWebFeaturesCrossPlayGetEventRulesEndpoint(game, initOverrides) {
        const response = await this.fxIdWebFeaturesCrossPlayGetEventRulesEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesCrossPlayGetMyQuestsEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/cross-play/quests/my`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSON));
    }
    /**
     */
    async fxIdWebFeaturesCrossPlayGetMyQuestsEndpoint(initOverrides) {
        const response = await this.fxIdWebFeaturesCrossPlayGetMyQuestsEndpointRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesCrossPlaySendInGameEventEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesCrossPlaySendInGameEventRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesCrossPlaySendInGameEventRequest', 'Required parameter "fxIdWebFeaturesCrossPlaySendInGameEventRequest" was null or undefined when calling fxIdWebFeaturesCrossPlaySendInGameEventEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/cross-play/events/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSON(requestParameters['fxIdWebFeaturesCrossPlaySendInGameEventRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fxIdWebFeaturesCrossPlaySendInGameEventEndpoint(fxIdWebFeaturesCrossPlaySendInGameEventRequest, initOverrides) {
        await this.fxIdWebFeaturesCrossPlaySendInGameEventEndpointRaw({ fxIdWebFeaturesCrossPlaySendInGameEventRequest: fxIdWebFeaturesCrossPlaySendInGameEventRequest }, initOverrides);
    }
}
//# sourceMappingURL=CrossPlayApi.js.map